import { render, staticRenderFns } from "./ViewEstablishmentTransferPage.vue?vue&type=template&id=01ba5a6c"
import script from "./ViewEstablishmentTransferPage.vue?vue&type=script&lang=js"
export * from "./ViewEstablishmentTransferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports